import data from 'store/data';

export function useData() {
  return data;
}
